import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilePlus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M9.25 18.25h-3.5a2 2 0 0 1-2-2V3.75a2 2 0 0 1 2-2h5.5m0 0 5 5m-5-5v5h5m0 0v2.5M12.75 16H16m0 0h3.25M16 16v-3.25M16 16v3.25"
	})]
});
const ForwardRef = forwardRef(SvgFilePlus);
export { ForwardRef as ReactComponent };
